import React from 'react';
import TrackingMap from '../components/TrackingMap';

const Rastreamento: React.FC = () => {
  return (
    <div 
      className="h-screen bg-white"
      style={{
        margin: 0,
        padding: 0,
        position: 'fixed',
        top: 0,
        left: '16rem', // 64 = 16rem (largura da sidebar)
        right: 0,
        bottom: 0,
        zIndex: 10
      }}
    >
      {/* Mapa em tela cheia */}
      <div className="h-full w-full">
        <TrackingMap className="h-full w-full" showHeader={false} />
      </div>
    </div>
  );
};

export default Rastreamento;
